import { render, staticRenderFns } from "./CalendarWeek.vue?vue&type=template&id=b025a4d2&scoped=true&lang=pug&"
import script from "./CalendarWeek.vue?vue&type=script&lang=js&"
export * from "./CalendarWeek.vue?vue&type=script&lang=js&"
import style0 from "./CalendarWeek.vue?vue&type=style&index=0&id=b025a4d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b025a4d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VIcon,VLayout})
